<template>
  
  <div :id="_uid" class="ui tiny modal" :class="modalSelector">
    <div class="ui header">
      Atenção
    </div>
    <div class="content">
      <p class="m-b-20">Esse registro não pode ser excluído porque está associado às seguintes entidades:</p>
      <p v-for="entity in entities" class="bold text">
        {{ entity.name }}
      </p>        
    </div>
    <div class="actions">
      <button class="ui blue button" @click="hide()">
        <i class="check icon"></i>
        Ok, entendi
      </button>      
    </div>
  </div>

</template>

<script>

  export default {

    name: "CanNotRemoveModal",

    data() {
      return {
        entities: [],
      }
    },

    mounted() {
      $("#" + this._uid).modal({ allowMultiple: true })
    },
    
    beforeDestroy() {
      $("." + this.modalSelector).remove()
    },

    computed: {

      modalSelector() {
        return this._uid + "_modal"
      },
    },

    methods: {

      show(entities) {
        this.entities = entities.slice()
        $("#" + this._uid).modal("show")
      },

      hide() {
        $("#" + this._uid).modal("hide")
      },
    },
  }

</script>

